import ResponsibilityTable from "./responsibility-table";

export default ResponsibilityTable;
